import React, {useEffect} from 'react'
import {Grid, FormControlLabel, CircularProgress} from '@mui/material'
import participantsApi from '../../../services/api/participants/participantsApi'
import {getMatSites} from '../../../utils/utilities'
import ShowParticipantList from './showParticipantList.jsx'
import WbSwitch from '../../../components/common/WbSwitch.jsx'
import SelectSchool from './SelectSchools.jsx'
import ParticipantFilters from './ParticipantFilters.jsx'
import {getApiHookParams} from '../../../auth'
import {withSchoolScope} from '../checkInWizardRules'

export default function SelectParticipants({
  count,
  setCount,
  participantFilter,
  setParticipantFilter,
}) {
  const [loading, setLoading] = React.useState(false)
  const apiParams = getApiHookParams()
  const [schools, setSchools] = React.useState([])
  const [availableFilters, setAvailableFilters] = React.useState([])

  const getFilters = async () => {
    setLoading(true)
    let accessibleSchoolIds = []

    // Whether this is a trust and which trust comes from the session's access control, the same
    // source every other API call here uses. Reading a 'customer' object from browser storage
    // instead left an Identity sign-in with no schools, no participant count and nothing to invite.
    if (apiParams.isMat && apiParams.groupId) {
      var res = await participantsApi.getSchoolsByMatId(apiParams.groupId)
      if (apiParams.schoolIds && apiParams.schoolIds.length > 0) {
        res = res.filter(x => apiParams.schoolIds.includes(x.id))
      } else {
        const sites = getMatSites(apiParams)
        if (Array.isArray(sites) && sites.length > 0 && sites[0] !== '0') {
          res = res.filter(x => sites.includes('' + x.id))
        }
      }
      setSchools(res)
      accessibleSchoolIds = res.map(school => school.id)
    }

    let avlFitlers = await participantsApi.getParticipantFilters(
      apiParams.isMat ? 0 : apiParams.schoolId,
      apiParams.isMat ? apiParams.groupId : 0,
      false,
      true,
      false
    )
    setAvailableFilters(avlFitlers)

    setParticipantFilter(
      withSchoolScope(participantFilter, {
        isMat: apiParams.isMat,
        schoolId: apiParams.schoolId,
        accessibleSchoolIds,
      })
    )
    setLoading(false)
  }
  useEffect(() => {
    getFilters()
  }, [])

  if (loading) return <CircularProgress />

  return (
    <>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={4}>
          <h3>
            <strong>Select Participants</strong>
          </h3>
        </Grid>

        <Grid item lg={12} md={12} sm={12} xs={12} my={2}>
          <div className="participants">
            <div className="participant-filter-box">
              <div className="participant-filter">
                <FormControlLabel
                  label="All Students"
                  control={
                    <WbSwitch
                      size="small"
                      checked={participantFilter.allStudent}
                      onChange={e => {
                        setParticipantFilter({
                          ...participantFilter,
                          allStudent: e.target.checked,
                        })
                      }}
                    />
                  }
                />
                {!participantFilter.allStudent && apiParams.isMat && (
                  <div
                    className="participant-filter"
                    style={{margin: '15px 0'}}
                  >
                    <SelectSchool
                      participantFilter={participantFilter}
                      setParticipantFilter={setParticipantFilter}
                      schools={schools}
                    />
                  </div>
                )}
                {!participantFilter?.allStudent && (
                  <ParticipantFilters
                    participantFilter={participantFilter}
                    setParticipantFilter={setParticipantFilter}
                    audience={'Student'}
                    updateInDb={() => {}}
                    availableFilter={[
                      ...availableFilters.filter(x => x.audience === 'Student'),
                    ]}
                  />
                )}
              </div>
            </div>
          </div>
        </Grid>

        <ShowParticipantList
          count={count}
          setCount={setCount}
          participantFilter={participantFilter}
        />
      </Grid>
    </>
  )
}
